import { TituloAbaService } from './../titulo-aba/titulo-aba.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { elementAt } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
// import data from '../../post.json'

@Component({
  selector: 'app-post-detail',
  templateUrl: './post-detail.component.html',
  styleUrl: './post-detail.component.scss'
})
export class PostDetailComponent implements OnInit {
  constructor(private route: ActivatedRoute, private http: HttpClient, private tituloAbaService: TituloAbaService) { }
  arrayNew: any
  data: any
  id: any

  public env = environment
  public apiUrl = `${this.env.origin}/blogmidias/post.json`;

  async ngOnInit(): Promise<void> {
    setTimeout(() => {
      window.scrollTo(0, 0)
      document.documentElement.scrollTop = 0; // Para navegadores modernos
      document.body.scrollTop = 0; // Para navegadores mais antigos
    }, 0);
   
    this.id = this.route.snapshot.paramMap.get('id');
    await this.getData()
    this.tituloAbaService.setTitle(this.arrayNew.title)
    this.tituloAbaService.setMeta('description', this.arrayNew.description);
    this.tituloAbaService.setMeta('image', `${this.env.origin}/blogmidias/${this.arrayNew.postId}.jpg`);
    this.tituloAbaService.setMeta('imageAlt', `${this.arrayNew.altImg}`);

  }
  async getData() {
    try {
      const response = await this.http.get(this.apiUrl).toPromise();
      this.data = response as any[];  // Assegura que response seja tratado como um array
      this.arrayNew = this.data.find((element: any) => element.postId == this.id)
    } catch (error) {
      console.log('Erro ao buscar dados', error);
    }
  }
}
